import React, { Fragment } from "react";
import Helmet from "react-helmet";
import cn from "classnames";
import "swiper/dist/css/swiper.min.css";
import "./index.styl";
import LoginATI from "../components/Auth/Login";
import loginImage from "../images/login-image.jpg";

const Page = () => (
  <Fragment>
    <Helmet
      title="Login"
    />
    <header
      className={cn('c-header', 'c-header--full', 't-context--dark', 'bg')}
      style={{ backgroundImage: `url(${loginImage})` }}
    >
      <LoginATI name="atiLogin" source="login" />
    </header>
  </Fragment>
);

export default Page;



// WEBPACK FOOTER //
// ./src/pages/login.js